module.exports = __webpack_public_path__ + "static/media/github.006ad889.svg";